// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import store from "../../store";
// Define a service using a base URL and expected endpoints
export const dispatchApi = createApi({
  reducerPath: "dispatchApi",
  baseQuery: fetchBaseQuery({
    prepareHeaders: (headers, { getState }) => {
      //   if (accessToken) {
      headers.set(
        "authorization",
        `Bearer ${store.getState().allotracDispatch.dispatchAuth.access_token}`
      );
      //   }
      return headers;
    },

    baseUrl:
      "https://data.optimize.allotr.ac:8080/https://sandbox.allotrac.com.au/api/allotrac/"
  }),
  endpoints: builder => ({
    getContact: builder.query({
      query: params => {
        return {
          url: `/contact.php`,
          params: params
        };
      }
    }),

    getSubContact: builder.query({
      query: params => {
        return {
          url: `/subcontacts.php`,
          params: params
        };
      }
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetContactQuery, useGetSubContactQuery } = dispatchApi;
